var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCredentialIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "size=32px, state=default",
    clipPath: "url(#clip0_3791_29582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.9999 5.33334H3.99992C2.52716 5.33334 1.33325 6.52724 1.33325 8V24C1.33325 25.4728 2.52716 26.6667 3.99992 26.6667H27.9999C29.4727 26.6667 30.6666 25.4728 30.6666 24V8C30.6666 6.52724 29.4727 5.33334 27.9999 5.33334Z",
    stroke: "#1E1E20",
    strokeWidth: 2.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.7893 15.5238L26.7893 15.5238",
    stroke: "#1E1E20",
    strokeWidth: 2.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.4561 20.8571L26.7894 20.8571",
    stroke: "#1E1E20",
    strokeWidth: 2.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 6.78931,
    y: 10.1904,
    width: 5.33333,
    height: 5.33333,
    rx: 1.341,
    stroke: "#1E1E20",
    strokeWidth: 2.67
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3791_29582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialIcon);
export default __webpack_public_path__ + "static/media/credentialIcon.b1993d406fa51aadda50228f059079e4.svg";
export { ForwardRef as ReactComponent };